const aboutUrl = '/about';

export default aboutUrl;
